import React, { Fragment } from 'react';
import styled from 'styled-components';
import { StackedArea, useStackableContent } from './StackableContentContext';
const StackableAreaWrapper = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
`;
const StackableContentWrapper = styled.div `
  position: relative;
  min-height: calc(
    100vh - ${({ theme }) => theme.distances.desktopHeaderHeight}px
  );
  max-height: calc(
    100vh - ${({ theme }) => theme.distances.desktopHeaderHeight}px
  );
  overflow: hidden;
  margin-left: ${({ theme }) => theme.distances.desktopSidebarWidth}px;
  width: calc(100% - ${({ theme }) => theme.distances.desktopSidebarWidth}px);
`;
const StackablePageWrapper = styled.div `
  position: relative;
  min-height: calc(
    100vh - ${({ theme }) => theme.distances.desktopHeaderHeight}px
  );
  max-height: calc(
    100vh - ${({ theme }) => theme.distances.desktopHeaderHeight}px
  );
  overflow: hidden;
`;
const StackedContentWrapper = styled.div `
  background-color: #fff;
  z-index: 10;
  overflow: auto;
  position: absolute;
  inset: 0;
`;
// Component used to render stackable content in.
// This wraps around the element in the dom the content should be stacked ABOVE.
// Checks the active stacked content and sees if it matches the current area type
// If the area type of the stackable content and this component match, the component can be rendered here.
const StackableArea = ({ area, children }) => {
    const { activeStackedContent } = useStackableContent();
    if (activeStackedContent && activeStackedContent.area === area) {
        if (activeStackedContent.area === StackedArea.PAGE) {
            return (React.createElement(StackablePageWrapper, null,
                React.createElement(StackedContentWrapper, { key: `stackable-content-${activeStackedContent.id}` }, activeStackedContent.renderComponent()),
                children));
        }
        if (activeStackedContent.area === StackedArea.CONTENT) {
            return (React.createElement(StackableContentWrapper, null,
                React.createElement(StackedContentWrapper, { key: `stackable-content-${activeStackedContent.id}` }, activeStackedContent.renderComponent()),
                children));
        }
        return (React.createElement(StackableAreaWrapper, null,
            React.createElement(StackedContentWrapper, { key: `stackable-content-${activeStackedContent.id}` }, activeStackedContent.renderComponent()),
            children));
    }
    else {
        return React.createElement(Fragment, null, children);
    }
};
export default StackableArea;
